enum SVG_ENUM {
  LOGO = "logo",
  EYE = "eye",
  CROSSED_EYE = "crossed-eye",
  CLOSE_CIRCLE = "close-circle",
  CLOSE_CIRCLE_GRAY = "close-circle-gray",
  CLOUD_UPLOAD = "cloud-upload",
  EP_SUCCESS = "ep-success",
  EP_FAIL = "ep-fail",
  FILTER = "filter",
  PAUSE_CIRCLE = "pause-circle",
  PLAY_CIRCLE = "play-circle",
  BACK_CHEVRON = "back-chevron",
  SHOPPING_CART = "shopping-cart",
  TAG = "tag",
  USERS = "users",
  STOP_SIGN = "stop-sign",
  EDIT = "edit",
  SQUARE_CHECK = "square-check",
  CHEVRON_UP = "chevron-up",
  CHEVRON_DOWN = "chevron-down",
  ARROW_LEFT = "arrow-left",
  TRENDING_UP = "trending-up",
}

export default SVG_ENUM;
